
import React, { useState } from "react";
import "./glossariymain.scss";
import SearchBar from "./SearchBar";
import GlossaryCard from "./GlossaryCard";
import Pagination from "./Pagination";
import { terms } from "./terms";

const Glos = () => {
  const [search, setSearch] = useState("");
  const [copiedTerm, setCopiedTerm] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const termsPerPage = 12;

  const filteredTerms = terms
    .sort((a, b) => a.word.localeCompare(b.word))
    .filter((term) => term.word.toLowerCase().includes(search.toLowerCase()));

  const indexOfLastTerm = currentPage * termsPerPage;
  const indexOfFirstTerm = indexOfLastTerm - termsPerPage;
  const currentTerms = filteredTerms.slice(indexOfFirstTerm, indexOfLastTerm);
  const totalPages = Math.ceil(filteredTerms.length / termsPerPage);

  return (
    <div className="glossary-container">
      <h1 className="glossary-title">Глоссарий</h1>
      <SearchBar search={search} setSearch={setSearch} />
      <div className="glossary-grid">
        {currentTerms.length > 0 ? (
          currentTerms.map((term, index) => (
            <GlossaryCard
              key={index}
              term={term}
              index={index}
              copiedTerm={copiedTerm}
              setCopiedTerm={setCopiedTerm}
            />
          ))
        ) : (
          <p className="no-results">Ничего не найдено</p>
        )}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={setCurrentPage}
      />
    </div>
  );
};

export default Glos;
